(function () {
    'use strict';

    angular.module("imApp").factory("orderLineCancelCauseService", ['$ihttp', function ($ihttp) {
        let service = {
            getOrderLineCancelCause: function (parms) {
                return $ihttp.post({
                    method: 3326,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3327,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
